import { isEmpty } from "lodash";

export const hasValue = (value: any) => {
  if (Array.isArray(value)) {
    return !!value.length
  }

  if (typeof value === 'object' && isEmpty(value)) {
    return false
  }

  if (typeof value === 'number') {
    return true
  }

  return !!value
}